import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  TransferDeleteInput,
  TransferModel,
  TransferMutationInput,
  TransferUpdateInput,
} from './model';

export function useCreateTransfer(
  options?: UseMutationOptions<
    ApiResult<TransferModel>,
    ApiError,
    TransferMutationInput
  >,
): UseMutationResult<
  ApiResult<TransferModel>,
  ApiError,
  TransferMutationInput
> {
  return useMutation<ApiResult<TransferModel>, ApiError, TransferMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'transfers',
        method: 'POST',
        classType: TransferModel,
        body,
      });
    },
    options,
  );
}

export function useUpdateTransfer(
  options?: UseMutationOptions<
    ApiResult<TransferModel>,
    ApiError,
    TransferUpdateInput
  >,
): UseMutationResult<ApiResult<TransferModel>, ApiError, TransferUpdateInput> {
  return useMutation<ApiResult<TransferModel>, ApiError, TransferUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `transfers/${body.transferId}`,
        method: 'PUT',
        classType: TransferModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useDeleteTransfer(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    TransferDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, TransferDeleteInput> {
  return useMutation<{ message: string }, ApiError, TransferDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `transfers/${body.transferId}/void`,
        method: 'PATCH',
      });
    },
  );
}
